// extracted by mini-css-extract-plugin
export default {"container":"dl-z","links":"el-z"};